import { api } from './client';

/** Equipe do escritório (docs/PLANO_COMPARTILHAMENTO_ESCRITORIO.md R6): para escolher com quem compartilhar. */
export interface Equipe {
  id: string;
  nome: string;
  cor: string | null;
  membros: { usuario_id: string; usuario_nome: string }[];
  created_at: string;
}

export interface EquipePayload {
  nome?: string;
  /** `null` remove a cor; ausente, não mexe. */
  cor?: string | null;
  membro_ids?: string[];
}

export async function fetchEquipes(escritorioId: string): Promise<Equipe[]> {
  const { data } = await api.get<Equipe[]>(`/escritorios/${escritorioId}/equipes`);
  return data;
}

export async function criarEquipe(
  escritorioId: string,
  payload: Required<Pick<EquipePayload, 'nome'>> & EquipePayload,
): Promise<Equipe> {
  const { data } = await api.post<Equipe>(`/escritorios/${escritorioId}/equipes`, payload);
  return data;
}

export async function atualizarEquipe(escritorioId: string, equipeId: string, payload: EquipePayload): Promise<Equipe> {
  const { data } = await api.put<Equipe>(`/escritorios/${escritorioId}/equipes/${equipeId}`, payload);
  return data;
}

export async function excluirEquipe(escritorioId: string, equipeId: string): Promise<void> {
  await api.delete(`/escritorios/${escritorioId}/equipes/${equipeId}`);
}
